module.exports = __webpack_public_path__ + "img/icon_close.caa4dab2.png";